module.exports = __webpack_public_path__ + "img/APL.105c80f2.svg";